import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=16b9fd3b&scoped=true&"
import script from "./EditForm.vue?vue&type=script&lang=ts&"
export * from "./EditForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=16b9fd3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b9fd3b",
  null
  
)

export default component.exports